module.exports = __webpack_public_path__ + "img/companion_2.812f4e30.svg";